import SZModal from '@/components/common/SZModal';
import { useSnapshot } from '@umijs/max';

import { createWorkspace, getUserSharingTree } from '@/services/workbench';
import { CreateWorkSpaceReq } from '@/services/workbench/type';
import { useNavigate } from '@umijs/max';
import { Form, Input, message } from 'antd';
import debounce from 'lodash/debounce';
import memorize from 'lodash/memoize';
import { useCallback, useEffect, useMemo } from 'react';
import { DepartmentMemberOrgEnum } from '../MemberSelectModal/interface';
import InputTag from './InputTag';
import styles from './index.less';
import { resetStore, store } from './store';
//FIX: 这个类型有错误
type FormType = {
  collaborators: {
    avatar?: string;
    key: string;
    label: string;
    type: number;
    value: string;
  }[];
} & CreateWorkSpaceReq;

enum FormItemNames {
  workspace_name = 'workspace_name',
  workspace_desc = 'workspace_desc',
  collaborators = 'collaborators',
}

const FormTextMap = {
  [FormItemNames.workspace_name]: '空间名称',
  [FormItemNames.workspace_desc]: '空间说明',
  [FormItemNames.collaborators]: '协作者',
  // [FormItemNames.notification]: '通知协作者',
};

interface Props {
  visible: boolean;
  onCancel?: () => void;
  onOk?: () => void;
}

const InputSuffix = (
  value: undefined | string | number,
  maxLength: string | number,
) => {
  return (
    <span className={styles['input-suffix']}>
      {String(value || '').length}/{maxLength}
    </span>
  );
};

const useWatch = Form.useWatch;
const useForm = Form.useForm;
const maxNameLength = 50;
const maxDesLength = 200;

const labelText = memorize((value: string) => {
  return <span style={{ color: '#777A80' }}>{value}</span>;
});

const formLayout = { labelCol: { span: 4 }, wrapperCol: { span: 20 } };

const CreateWorkSpaceModal = ({ visible, onCancel, onOk }: Props) => {
  const navigate = useNavigate();
  const [form] = useForm<FormType>();
  const snap = useSnapshot(store) as typeof store;

  // 监听name字段
  const nameField = useWatch(FormItemNames.workspace_name, form);

  // 监听des字段
  const descriptionField = useWatch(FormItemNames.workspace_desc, form);

  // name字段字数统计后缀
  const NameSuffix = useMemo(
    () => InputSuffix(nameField, maxNameLength),
    [nameField],
  );
  // des字段字数统计后缀
  const DescriptionSuffix = useMemo(
    () => InputSuffix(descriptionField, maxDesLength),
    [descriptionField],
  );
  // 获取分享树方法
  const getData = (params: {
    resource_code?: number | string;
    resource_type: number;
    keyword?: string;
    dept_uid?: string;
  }) => {
    store.loading = true;
    getUserSharingTree(params).then(({ data }) => {
      const { dept_infos = [], users = [] } = data || {};

      const departmentList = dept_infos.map((item) => {
        return {
          key: item.dept_uid,
          disabled: item.is_bind,
          label: item.dept_name,
          value: item?.dept_uid,
          type: DepartmentMemberOrgEnum.DEPARTMENT,
        };
      });

      const userList = users.map((item) => {
        return {
          key: item.ou_uid,
          value: item.ou_uid,
          disabled: item.is_bind,
          label: item.username,
          avatar: item?.avatar,
          type: DepartmentMemberOrgEnum.USER,
        };
      });

      store.userList = userList;
      store.departmentList = departmentList;
      store.loading = false;
    });
  };
  // 新建空间
  const handleOk = useCallback(async () => {
    const formValues = form.getFieldsValue();

    const collaborators = formValues.collaborators?.map((item) => {
      return {
        entity_type: item?.type,
        uid: item.value,
      };
    });
    const data = await createWorkspace({
      ...formValues,
      collaborators,
    });
    if (data) {
      navigate(
        `/empty/${data.workspace_id}/${data.workspace_uid}?code=4&id=${data.workspace_id}&uid=${data.workspace_uid}`,
      );
      message.success('新建成功');
      onOk?.();
    } else {
      message.error('新建失败');
    }
  }, [form, onOk]);

  useEffect(() => {
    if (visible === false) {
      resetStore();
      form.resetFields();
    }
  }, [visible]);

  useEffect(() => {
    if (snap.memberSelectModalVisible === true) {
      getData({
        resource_type: 5,
      });
    }
  }, [snap.memberSelectModalVisible]);

  useEffect(() => {
    if (snap.memberSelectModalVisible === true) {
      getData({
        resource_type: 5,
        dept_uid: snap.curDepartmentId || undefined,
        keyword: snap.curSearchValue,
      });
    }
  }, [snap.curDepartmentId, snap.curSearchValue]);

  return (
    <SZModal
      title="新建工作空间"
      OKBtnDisable={!nameField}
      open={visible}
      destroyOnClose={true}
      onCancel={() => {
        onCancel?.();
      }}
      onOk={debounce(handleOk, 1500, { leading: true })}
    >
      <Form {...formLayout} form={form} className={styles['form-wrapper']}>
        <Form.Item
          colon={false}
          required
          label={labelText(FormTextMap.workspace_name)}
          name={FormItemNames.workspace_name}
        >
          <Input
            placeholder="输入空间名称"
            maxLength={maxNameLength}
            suffix={NameSuffix}
            style={{
              height: '40px',
            }}
          />
        </Form.Item>
        <Form.Item colon={false} label={labelText(FormTextMap.workspace_desc)}>
          <>
            <Form.Item name={FormItemNames.workspace_desc} noStyle={true}>
              <Input.TextArea
                className={styles['text-area']}
                maxLength={maxDesLength}
                placeholder="输入空间介绍说明"
              />
            </Form.Item>
            <span className={styles['text-count']}>{DescriptionSuffix}</span>
          </>
        </Form.Item>
        <Form.Item
          label={labelText(FormTextMap.collaborators)}
          name={FormItemNames.collaborators}
          colon={false}
        >
          <InputTag />
        </Form.Item>
        {/* 通知字段 这一期先不上 */}
        {/* <Form.Item
          name={FormItem.notification}
          colon={false}
          wrapperCol={{ offset: 4, span: 20 }}
          className={styles['checkbox-wrapper']}
          initialValue={false}
          valuePropName="checked"
        >
          <Checkbox>{FormTextMap.notification}</Checkbox>
        </Form.Item> */}
      </Form>
    </SZModal>
  );
};

export default CreateWorkSpaceModal;
